/*
 *
 *  Created by Sébastien Hecart on 2018-10-27 14:12:13 +0000.
 *  Copyright © 2017 Sebastien Hecart. All rights reserved.
 *
 *
 */

import { fetchDegreJourUnifie } from '@batical/data/src'
import { I04CONSCHAUFAN_State } from '@batical/types/src'

function I04CONSCHAUFAN_docalcul(state: I04CONSCHAUFAN_State, _isWeb = false) {
  if (state.in_temperatureAmbiante === state.in_tempExtBase) {
    state.res_consoAnnuelle = 0
    state.dataChart = []
    return state
  }

  const dju = fetchDegreJourUnifie(state.dju_uuid)

  if (dju) {
    //= (C4*24-C7*C8*C9)/(C4*24)
    state.res_intermittence =
      (dju.average * 24 - state.in_nbJourChauffe * state.in_nombreHeureReduit * state.in_nombreDegreAbaisse) / (dju.average * 24)

    let dataChartServer: Array<{ mois: string; y: number }> = []

    const variationDJU = dju.average + (state.in_temperatureAmbiante - 18) * state.in_nbJourChauffe
    let fixValue = (state.in_deperdition / (state.in_temperatureAmbiante - state.in_tempExtBase)) * 24

    state.res_consoAnnuelle =
      fixValue * (dju.average + (state.in_temperatureAmbiante - 18) * state.in_nbJourChauffe) * state.res_intermittence

    fixValue = (fixValue * variationDJU) / dju.average
    //data in dju table were created like shit.. thanks to the spec, so cannot iterate throug monthly value....
    dataChartServer = [
      { mois: 'Janvier', y: 0 },
      { mois: 'Février', y: 0 },
      { mois: 'Mars', y: 0 },
      { mois: 'Avril', y: 0 },
      { mois: 'Mai', y: 0 },
      { mois: 'Juin', y: 0 },
      { mois: 'Juillet', y: 0 },
      { mois: 'Août', y: 0 },
      { mois: 'Septembre', y: 0 },
      { mois: 'Octobre', y: 0 },
      { mois: 'Novembre', y: 0 },
      { mois: 'Décembre', y: 0 }
    ]

    if (!isNaN(fixValue * dju.m1)) {
      dataChartServer[0] = { mois: 'Janvier', y: Math.round(fixValue * dju.m1) }
    }
    if (!isNaN(fixValue * dju.m2)) {
      dataChartServer[1] = { mois: 'Février', y: Math.round(fixValue * dju.m2) }
    }
    if (!isNaN(fixValue * dju.m3)) {
      dataChartServer[2] = { mois: 'Mars', y: Math.round(fixValue * dju.m3) }
    }
    if (!isNaN(fixValue * dju.m4)) {
      dataChartServer[3] = { mois: 'Avril', y: Math.round(fixValue * dju.m4) }
    }
    if (!isNaN(fixValue * dju.m5)) {
      dataChartServer[4] = { mois: 'Mai', y: Math.round(fixValue * dju.m5) }
    }
    if (!isNaN(fixValue * dju.m6)) {
      dataChartServer[5] = { mois: 'Juin', y: Math.round(fixValue * dju.m6) }
    }
    if (!isNaN(fixValue * dju.m7)) {
      dataChartServer[6] = { mois: 'Juillet', y: Math.round(fixValue * dju.m7) }
    }
    if (!isNaN(fixValue * dju.m8)) {
      dataChartServer[7] = { mois: 'Aout', y: Math.round(fixValue * dju.m8) }
    }
    if (!isNaN(fixValue * dju.m9)) {
      dataChartServer[8] = { mois: 'Septembre', y: Math.round(fixValue * dju.m9) }
    }
    if (!isNaN(fixValue * dju.m10)) {
      dataChartServer[9] = { mois: 'Octobre', y: Math.round(fixValue * dju.m10) }
    }
    if (!isNaN(fixValue * dju.m11)) {
      dataChartServer[10] = { mois: 'Novembre', y: Math.round(fixValue * dju.m11) }
    }
    if (!isNaN(fixValue * dju.m12)) {
      dataChartServer[11] = { mois: 'Décembre', y: Math.round(fixValue * dju.m12) }
    }
    state.dataChart = dataChartServer
  }

  state.invalidated = false
  return state
}

export default I04CONSCHAUFAN_docalcul
